module.exports = __webpack_public_path__ + "img/2022-11-24_11-56-04.d320b85c.jpg";